import { reverse } from 'named-urls'
import React from 'react'

import { ButtonClean, Tag } from '@fourthwall/components'
import { routing } from '@utils/routing'

import type { Product } from '../../../../../../../__models__'
import * as S from './CatalogProductDetails.styled'

type CatalogProductDetailsProps = {
  product: Product
}

export const CatalogProductDetails = ({ product }: CatalogProductDetailsProps) => {
  if (!product) {
    return null
  }

  return (
    <>
      {product.status === 'DISCONTINUED' && (
        <S.Status>
          <Tag display="inline-flex" label="Discontinued" appearance="default" />
        </S.Status>
      )}
      <p>
        {product.name} by {product.brandName}
      </p>
      <ButtonClean
        label="View details"
        href={reverse(routing.productCatalog.product, { slug: product.slug })}
        target="_blank"
      />
    </>
  )
}
